// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border-radius-large {
  border-radius: 16px !important;
  overflow: hidden;
}
.border-right-large {
  border-right-width: 24px !important;
}
.border-left-large {
  border-left-width: 24px !important;
}
.border-top-large {
  border-top-width: 24px !important;
}
.border-bottom-large {
  border-bottom-width: 24px !important;
}
.mw-100 {
  max-width: 100%;
}
.h-100 {
  height: 100%;
}
.d-block {
  display: block;
}
.tag-rounded {
  border-radius: 100% !important;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-neutral-light-lighter);
}
.vert-bg-white {
  background: #FFF;
}
.resize-collapse {
  max-width: 90% !important;
}
.ant-collapse-item .ant-collapse-header-text {
  font-weight: 600;
}
.ant-collapse-item .arrow-collpase {
  transition: transform 0.3s ease;
}
.ant-collapse-item .arrow-collpase.color-detached {
  color: var(--color-detached) !important;
}
.ant-collapse-item.ant-collapse-item-active .arrow-collpase {
  transform: rotate(180deg);
}
@media screen and (max-width: 768px) {
  .card-img-likemais {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/LikePlus/LikePlusGeneric.less"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,gBAAA;AACJ;AAEA;EACI,mCAAA;AAAJ;AAGA;EACI,kCAAA;AADJ;AAIA;EACI,iCAAA;AAFJ;AAKA;EACI,oCAAA;AAHJ;AAMA;EACI,eAAA;AAJJ;AAOA;EACI,YAAA;AALJ;AAQA;EACI,cAAA;AANJ;AASA;EACI,8BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;AAPJ;AAUA;EACI,gBAAA;AARJ;AAWA;EACI,yBAAA;AATJ;AAaA;EAEQ,gBAAA;AAZR;AAUA;EAMQ,+BAAA;AAbR;AAeQ;EACI,uCAAA;AAbZ;AAiBI;EAEQ,yBAAA;AAhBZ;AAqBA;EACI;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;EAnBN;AACF","sourcesContent":[".border-radius-large {\n    border-radius: 16px !important;\n    overflow: hidden;\n}\n\n.border-right-large {\n    border-right-width: 24px !important;\n}\n\n.border-left-large {\n    border-left-width: 24px !important;\n}\n\n.border-top-large {\n    border-top-width: 24px !important;\n}\n\n.border-bottom-large {\n    border-bottom-width: 24px !important;\n}\n\n.mw-100 {\n    max-width: 100%;\n}\n\n.h-100 {\n    height: 100%;\n}\n\n.d-block {\n    display: block;\n}\n\n.tag-rounded {\n    border-radius: 100% !important;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--color-neutral-light-lighter);\n}\n\n.vert-bg-white {\n    background: #FFF;\n}\n\n.resize-collapse {\n    max-width: 90% !important;\n}\n\n\n.ant-collapse-item {\n    .ant-collapse-header-text {\n        font-weight: 600;\n    }\n\n    .arrow-collpase {\n        transition: transform 0.3s ease;\n\n        &.color-detached {\n            color: var(--color-detached) !important;\n        }\n    }\n\n    &.ant-collapse-item-active {\n        .arrow-collpase {\n            transform: rotate(180deg)\n        }\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .card-img-likemais {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
